// Page URLs are hashed before they leave the browser (PRE-3271): Mixpanel must
// never receive a raw customer URL, which can carry private paths or query
// tokens. cyrb53 is a small synchronous non-cryptographic hash — sync because
// this runs inline in a click handler, where Web Crypto's async digest is
// clumsy. The token is opaque and stable, so distinct/repeat clicks stay
// countable; it is not built to withstand a brute-force of already-known URLs,
// which is not the goal — keeping raw URLs out of analytics is.
export function hashPageUrl(url: string): string {
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < url.length; i += 1) {
    const ch = url.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(16);
}
